import { render, staticRenderFns } from "./TwCustomer.vue?vue&type=template&id=2a03aad6&"
import script from "./TwCustomer.vue?vue&type=script&lang=js&"
export * from "./TwCustomer.vue?vue&type=script&lang=js&"
import style0 from "./TwCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports